module.exports = __webpack_public_path__ + "green-tick-for-PDF.png?3d2a53071767c4332c8ebdcb675466aa";